import { createSlice } from "@reduxjs/toolkit";

// Helper to generate unique IDs
const generateId = () =>
  Math.random().toString(36).substring(2, 15) +
  Math.random().toString(36).substring(2, 15);

// initial state
const initialState = [];

// ==============================|| SLICE - NOTIFICATION ||============================== //

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    addNotification(state, action) {
      const existingNotif = state.find((x) => x.id === action.payload.id);
      if (existingNotif) {
        return state;
      }
      return [
        ...state,
        {
          id: generateId(),
          ...action.payload,
        },
      ];
    },
    removeNotification(state, action) {
      return state.filter((notification) => notification.id !== action.payload);
    },
    clearAllNotifications() {
      return [];
    },
  },
});

export default notificationSlice.reducer;

export const {
  addNotification,
  removeNotification,
  clearAllNotifications,
} = notificationSlice.actions;

// Legacy action type constants for backward compatibility during migration
export const NOTIFICATION_ACTION_TYPES = {
  ADD_NOTIFICATION: "notification/addNotification",
  REMOVE_NOTIFICATION: "notification/removeNotification",
};
